import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { User, Degree, Journal, Interest, Certification, Licensure, Honor } from '../shared/models/user';
import { MobileUiService } from '../shared/services/mobile-ui.service';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

export enum ProfileTab {
  biography,
  interests,
  degrees,
  certifications,
  honors,
  licensures,
  publications
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  profile = new BehaviorSubject<User>(null);
  dummyEl = document.createElement('DIV');
  loading: boolean;
  dummyPhoto = '../../assets/default-user.jpg';
  degrees = new Observable<Degree[]>(null);
  journals = new Observable<Journal[]>(null);
  interests = new Observable<Interest[]>(null);
  certifications = new Observable<Certification[]>(null);
  licensures = new Observable<Licensure[]>(null);
  honors = new Observable<Honor[]>(null);
  activeTab: ProfileTab = 0;
  isMobile = new BehaviorSubject<boolean>(false);
  faQuestionCircle = faQuestionCircle;
  isQuestion: boolean;

  constructor(
    private router: Router, private apiService: ApiService, private route: ActivatedRoute, private mobileUiService: MobileUiService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.apiService.getProfileById(params.id).subscribe(x => {
        if (x.id < 1) {
          this.router.navigateByUrl('/notfound');
          return;
        }
        x.biography = this.decode(x.biography);
        this.profile.next(x);
        this.degrees = this.apiService.getSectionByUserId<Degree>(x.id, 'Degrees');
        this.journals = this.apiService.getSectionByUserId<Journal>(x.id, 'Journals');
        this.interests = this.apiService.getSectionByUserId<Interest>(x.id, 'Interests');
        this.certifications = this.apiService.getSectionByUserId<Certification>(x.id, 'Certifications');
        this.licensures = this.apiService.getSectionByUserId<Licensure>(x.id, 'Licensures');
        this.honors = this.apiService.getSectionByUserId<Honor>(x.id, 'Honors');
        this.setIntialActiveTab(x);
      }, error => this.router.navigateByUrl('/notfound'));
    });
  }

  setActiveTab(tab: number): void {
    this.activeTab = tab;
  }

  formatPureProfileLink(firstName: string, lastName: string): string {
    const baseUrl = 'https://experts.unthsc.edu/en/persons/';
    const firstArray = firstName.split(' ');
    lastName = lastName.replace(' ', '-');


    if (firstArray[1] != null && firstArray[0].length === 1) {
      firstName = firstArray[1];
    }

    if (firstArray[1] != null && firstArray[0].length > 1) {
      firstName = `${firstArray[0]}-${firstArray[1]}`;
    }

    return `${baseUrl}${firstName.toLowerCase()}-${lastName.toLowerCase()}`;
  }

  private setIntialActiveTab(profile: User): void {
    if (profile.biography.length > 1) {
      this.setActiveTab(0);
      return;
    }

    if (profile.interests > 0) {
      this.setActiveTab(1);
      return;
    }

    if (profile.degrees > 0) {
      this.setActiveTab(2);
      return;
    }

    if (profile.certifications > 0) {
      this.setActiveTab(3);
      return;
    }

    if (profile.honors > 0) {
      this.setActiveTab(4);
      return;
    }

    if (profile.licensures > 0) {
      this.setActiveTab(5);
      return;
    }

    if (profile.journals > 0) {
      this.setActiveTab(6);
      return;
    }
  }

  private decode(text: string): string {
    let ret = '';
    this.dummyEl.innerHTML = text;
    document.body.appendChild(this.dummyEl);
    ret = this.dummyEl.textContent;
    document.body.removeChild(this.dummyEl);
    ret = ret.split('<p>&nbsp;</p>').join('');
    ret = ret.split('<strong>&nbsp;</strong>').join('');
    return ret;
  }

}
